if (customElements.get("yc-product-image-slider") === undefined) {
  class YcProductImageSlider extends HTMLElement {
    constructor() {
      //console.log("YcProductImageSlider");
      super();

      const images = this.querySelectorAll(".yc-product-slider__slide");
      this.imagesContainer = this.querySelector(".yc-product-slider__slides");

      this.prevButton = this.querySelector(".yc-product-slider__prev");
      this.nextButton = this.querySelector(".yc-product-slider__next");

      this.activeSlideIndex = 0;

      this.numberOfImages = images.length;
      this.indicatorArray = [];

      this.thumbnails = this.querySelectorAll(".yc-product-slider__thumbnail");

      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.setAttribute("data-index", index);
        thumbnail.addEventListener("click", () => {
          clearInterval(this.autoScrollInterval);
          this.activeSlideIndex = index;
          const scrollTo =
            (this.imagesContainer.scrollWidth / this.numberOfImages) *
            this.activeSlideIndex;
          this.imagesContainer.scrollTo({ left: scrollTo, behavior: "smooth" });
          this.updateControls();
        });
      });

      // add indicators
      const indicators = this.querySelector(
        ".yc-product-slider__image-indicators",
      );
      for (let i = 0; i < images.length; i++) {
        const indicator = document.createElement("div");
        indicator.classList.add("yc-product-image-slider__indicator");
        indicator.setAttribute("data-slide-to", i);
        if (i === 0) {
          indicator.classList.add("active");
        }
        indicators.appendChild(indicator);
        this.indicatorArray.push(indicator);

        indicator.addEventListener("click", () => {
          clearInterval(this.autoScrollInterval);
          this.scrollToSlide(i);
        });
      }

      this.prevButton.addEventListener("click", () => {
        clearInterval(this.autoScrollInterval);
        this.scrollToSlide(this.activeSlideIndex - 1);
      });

      this.nextButton.addEventListener("click", () => {
        clearInterval(this.autoScrollInterval);
        this.scrollToSlide(this.activeSlideIndex + 1);
      });

      this.updateControls();

      this.scrollToSlide = this.scrollToSlide.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      this.imagesContainer.addEventListener("scroll", this.handleScroll);
      //console.log("YcProductImageSlider - Constructed");
    }

    handleScroll = () => {
      const slideWidth = this.imagesContainer.scrollWidth / this.numberOfImages;
      const scrollLeft = this.imagesContainer.scrollLeft;
      const index = Math.round(scrollLeft / slideWidth);

      if (index !== this.activeSlideIndex) {
        this.activeSlideIndex = index;
        this.updateControls();
      }
    };

    scrollToSlide(index) {
      const scrollTo =
        (this.imagesContainer.scrollWidth / this.numberOfImages) * index;
      this.imagesContainer.scrollTo({ left: scrollTo, behavior: "smooth" });
    }

    updateControls() {
      this.indicatorArray.forEach((indicator, i) => {
        if (i === this.activeSlideIndex) {
          indicator.classList.add("active");
        } else {
          indicator.classList.remove("active");
        }
      });

      this.thumbnails.forEach((thumbnail, i) => {
        if (i === this.activeSlideIndex) {
          thumbnail.classList.add("active");
        } else {
          thumbnail.classList.remove("active");
        }
      });

      if (this.activeSlideIndex === 0) {
        this.prevButton.disabled = true;
      } else {
        this.prevButton.disabled = false;
      }

      if (this.activeSlideIndex === this.numberOfImages - 1) {
        this.nextButton.disabled = true;
      } else {
        this.nextButton.disabled = false;
      }
    }
  }

  customElements.define("yc-product-image-slider", YcProductImageSlider);
}
